<app-badge
  class="flex-row justify-content-between mb-y d-none d-lg-inline-flex"
  *ngIf="badge && badge.length > 0"
  [ngClass]="[badge!.toLowerCase()]"
  [badge]="badge"
></app-badge>
<div class="product-content">
  <div class="product-core pb-lg-3">
    <app-titles class="order-1 pb-2 pb-lg-0" [product]="product"></app-titles>
    <app-relation-picker
      class="order-2"
      *ngIf="product.metafields?.PRP?.lines"
      [relations]="_pickerRelations"
      [lines]="_lines"
      (selection)="selectOption($event.relation, $event.option)"
    ></app-relation-picker>
    <app-image-carousel
      [ngClass]="{ bump: product.metafields?.PRP?.lines }"
      class="d-lg-none order-3"
      [product]="product"
    ></app-image-carousel>
    <app-variant-picker
      class="mb-x order-4 order-lg-4"
      [lines]="_lines"
      (selection)="selectOption($event.relation, $event.option)"
      [relations]="_relations"
      [product]="product"
    ></app-variant-picker>
    <div
      class="richtext order-5 order-lg-3"
      [innerHtml]="product.body_html"
    ></div>
    <app-reviews class="order-6 order-lg-3" [product]="product"></app-reviews>

    <app-add-to-cart [product]="product" class="mb-x order-7"></app-add-to-cart>
  </div>
</div>
